export const Actions = {
  FETCH_FEATURES_REQUEST: 'glints/features/FETCH_FEATURES_REQUEST',
  FETCH_FEATURES_REQUEST_WITH_LOADING_MODAL:
    'glints/features/FETCH_FEATURES_REQUEST_WITH_LOADING_MODAL',
  FETCH_FEATURES_SUCCESS: 'glints/features/FETCH_FEATURES_SUCCESS',
  FETCH_FEATURES_FAILURE: 'glints/features/FETCH_FEATURES_FAILURE',
  SET_FEATURES: 'glints/features/SET_FEATURES',
};

export function setFeatures(features: Record<string, unknown>[]) {
  return {
    type: Actions.SET_FEATURES,
    payload: features,
  };
}
